import { PrivacyState } from "../interfaces/privacy-state.interface";

export const initialState: PrivacyState = {
  terms: [],
  error: null,
  isLoading: false,
  success: false,
};
